import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "rhombus-react";
import { confirmPreviews } from "reducers/Confirm";
import { extendCreativePreview } from "reducers/CreativePreviews";
import { pluralize } from "utils/common";

export default function BulkExtendPreviewsButton({ previews, disabled }) {
	const dispatch = useDispatch();
	const { libraryId } = useSelector(state => ({
		libraryId: state.libraryProperties.id,
	}));
	const plural = pluralize("", previews.length);
	const confirmProps = {
		libraryId,
		previews,
		title: `Confirm Extending Preview${plural} 90 Days`,
		commitLabel: `Extend 90 Days`,
		desc: `Are you sure you want to update the expiry date of the following shared preview${plural} to 90 days from now?`,
		commitTheme: "blue",
	};

	const handleClick = () => {
		return dispatch(confirmPreviews(extendCreativePreview, confirmProps, true));
	};

	return (
		<Button
			style="block"
			icon="fas fa-alarm-snooze"
			theme="blue"
			disabled={disabled}
			onClick={handleClick}
		>
			Extend 90 days
		</Button>
	);
}
